module.exports = __webpack_public_path__ + "static/media/alert.86fa2342.svg";